import { useRecordContext } from 'react-admin'
import { ImageField as BaseImageField } from 'react-admin'

export const ImageField = (props) => {
    const record = useRecordContext()

    if (!record) {
        return null
    }

    return <BaseImageField record={record} {...props} />
}

export default ImageField
